import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { LocalStorageService } from "./local-storage.service";
import { environment } from "../../../environments/environment";
import { UserDto } from "../../dtos/user-dto";
import { MessageService } from "./message.service";

const API_URL = environment.apiUrl;
@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  getRawResponse(
    url: string,
    responseType: any,
    params?: HttpParams
  ): Observable<any> {
    let headers: HttpHeaders = this.getToken();
    return this.http
      .get(API_URL + url, {
        headers: headers,
        params: params,
        responseType: responseType,
      })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError(this.messageService))
      );
  }

  get<T>(url: string, params?: HttpParams): Observable<any> {
    let headers: HttpHeaders = this.getToken();
    return this.http
      .get(API_URL + url, { headers: headers, params: params })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError(this.messageService))
      );
  }

  post<T>(url: string, data: any, params?: HttpParams) {
    return this.http
      .post(API_URL + url, data, { headers: this.getToken(), params: params })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError(this.messageService))
      );
  }

  put<T>(url: string, data: any) {
    return this.http
      .put(API_URL + url, data, { headers: this.getToken() })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError(this.messageService))
      );
  }

  delete<T>(url: string, params?: HttpParams) {
    let headers = this.getToken();
    return this.http
      .delete(API_URL + url, { headers: headers, params: params })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError(this.messageService))
      );
  }

  getUserLogued(): UserDto {
    let user: UserDto = new UserDto();
    let current = this.getLocalStorage();
    if (current) {
      user = JSON.parse(current);
    }
    return user;
  }

  private getToken(): HttpHeaders {
    let currentUser = this.getUserLogued();
    let headers = new HttpHeaders();
    let objTransfer = {
      l: currentUser.plants,
    };
    if (currentUser.token) {
      headers = new HttpHeaders({
        Authorization: "Bearer " + currentUser.token,
        IdCU: currentUser.id.toString(),
        CurrentUser: encodeURI(currentUser.username),
        auth: currentUser.auth.toString(),
        plants: currentUser.plants == null ? "" : currentUser.plants.toString(),
      });
    }
    return headers;
  }

  getLocalStorage() {
    let storage: any = "";
    if (this.localStorage) {
      storage = this.localStorage.getLocalStorage("currentUser");
    }
    return storage;
  }

  setLocalStorage(value: any) {
    if (this.localStorage) {
      this.localStorage.setLocalStorage("currentUser", value);
    }
  }

  removeLocalStorage() {
    if (this.localStorage) {
      this.localStorage.removeLocalStorage("currentUser");
    }
  }

  addLocalStorageByKey(key: string, value: any) {
    if (this.localStorage) {
      this.localStorage.setLocalStorage(key, value);
    }
  }

  removeLocalStorageByKey(key: string) {
    if (this.localStorage) {
      this.localStorage.removeLocalStorage(key);
    }
  }

  getLocalStorageByKey(key: string) {
    return this.localStorage.getLocalStorage(key);
  }

  private handleError(messageService: MessageService) {
    return (error: HttpErrorResponse): Observable<never> => {
      if (error.status == 400) {
        let code: string = "NOT_FOUND";
        let params;
        let areValues = false;
        if (error.error && error.error.code) {
          code = error.error.code;
        }
        if (error.error.values) {
          params = error.error.values;
          areValues = true;
        }

        messageService.warning(
          "GENERAL.MESSAGE.TITLE_WARNING",
          "GENERAL.ERROR." + code,
          params,
          null,
          areValues
        );
      } else {
        messageService.error(
          "GENERAL.MESSAGE.TITLE_ERROR",
          "GENERAL.MESSAGE.ERROR_MESSAGE"
        );
      }

      return throwError(error);
    };
  }
}
